<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Brödsmulor
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Navigeringsstig som visar var i hierarkin användaren befinner sig. Visas
      på receptsidan och kategorisidan (desktop only). Alla segment är versaler
      med
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >tracking-[1.4px]</span
      >.
    </p>

    <PreviewFull label="Receptsida — Recept / Kategori / Recepttitel">
      <div class="flex items-center gap-2">
        <a
          href="#"
          class="font-[Poppins] font-bold text-sm text-teal-500 tracking-[1.4px] uppercase no-underline"
          >Recept</a
        >
        <span class="font-[Poppins] font-bold text-sm text-teal-500">/</span>
        <a
          href="#"
          class="font-[Poppins] font-bold text-sm text-teal-500 tracking-[1.4px] uppercase no-underline"
          >Bakverk</a
        >
        <span class="font-[Poppins] font-bold text-sm text-teal-500">/</span>
        <span
          class="font-[Poppins] text-sm text-[#191c1e] tracking-[1.4px] uppercase"
          >Surdegsbröd med frön</span
        >
      </div>
    </PreviewFull>

    <PreviewFull label="Kategorisida — Recept / Kategorinamn">
      <div class="flex items-center gap-2">
        <a
          href="#"
          class="font-[Poppins] font-bold text-sm text-teal-500 tracking-[1.4px] uppercase no-underline"
          >Recept</a
        >
        <span class="font-[Poppins] font-bold text-sm text-teal-500">/</span>
        <span
          class="font-[Poppins] text-sm text-[#191c1e] tracking-[1.4px] uppercase"
          >Bakverk</span
        >
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Inertia Link används i stället för <a> -->
<div class="flex items-center gap-2">
  <Link
    href="/recept"
    class="font-[Poppins] font-bold text-sm text-teal-500 tracking-[1.4px] uppercase no-underline"
  >Recept</Link>

  <span class="font-[Poppins] font-bold text-sm text-teal-500">/</span>

  <!-- Mellanliggande kategorier (v-for i riktig app) -->
  <Link
    href="/kategorier/bakverk"
    class="font-[Poppins] font-bold text-sm text-teal-500 tracking-[1.4px] uppercase no-underline"
  >Bakverk</Link>

  <span class="font-[Poppins] font-bold text-sm text-teal-500">/</span>

  <!-- Aktuell sida — ej länk, mörkare färg -->
  <span class="font-[Poppins] text-sm text-[#191c1e] tracking-[1.4px] uppercase">
    Surdegsbröd med frön
  </span>
</div>`;

const cssCode = `/* Länktext (klickbara segment) */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;
color: #14b8a6;           /* text-teal-500 */
text-decoration: none;
letter-spacing: 1.4px;
text-transform: uppercase;

/* Separatorn  /  */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;
color: #14b8a6;

/* Aktuell sida (ej länk) */
font-family: 'Poppins', sans-serif;
font-weight: 400;         /* normal */
font-size: 14px;
color: #191c1e;
letter-spacing: 1.4px;
text-transform: uppercase;

/* Separator: / (teal, bold, same weight) — ej ›  */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
